import React, { useEffect, useState } from "react";
const slides = [
    {
        heading: "Virtual Support Assistant for SAP",
        subheading:
            "Welcome to Lisa – your on-demand AI assistant for all things SAP. Designed to provide real-time expert guidance. Our virtual analyst is available whenever you need, bridging the gap between technology and personalized support. Say goodbye to waiting and complicated troubleshooting. With just a call, you can connect to intelligent support that delivers instant and effective solutions."
    },
    {
        heading: "Revolutionizing Issue Resolution with AI for ServiceNow and Knowledge Networks",
        subheading:
            "Our AI agents integrate with ServiceNow, knowledge fabric, and external sources to enhance issue resolution. By analyzing historical and real-time data, they suggest solutions, automate workflows, and identify root causes. This results in streamlined operations, improved productivity, and an efficient user experience, transforming how organizations address challenges."
    },
    {
        heading: "Empathetic AI Voice Agents for Multilingual IT Support",
        subheading:
            "Our AI voice agents provide personalized IT support, adapting to preferences and handling multiple languages for global teams. With real-time sentiment analysis, they detect emotions and adjust responses for empathetic, context-aware support. These agents create a human-like, engaging experience, delivering faster resolutions and higher satisfaction."
    }
];
const Carousel: React.FC = () => {
    const [currentSlide, setCurrentSlide] = useState(1);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            handleSlideChange((currentSlide + 1) % slides.length);
        }, 5000); // Change every 5 seconds
        return () => clearInterval(interval);
    }, [currentSlide, slides.length]);

    const handleSlideChange = (nextSlide: number) => {
        setIsAnimating(true);
        setTimeout(() => {
            setCurrentSlide(nextSlide);
            setIsAnimating(false);
        }, 500); // Animation duration matches CSS duration
    };

    // const goToSlide = (index: number) => {
    //     setAnimate(false); // Disable animation during the transition
    //     setTimeout(() => {
    //         setCurrentSlide(index); // Move to the selected slide
    //         setAnimate(true); // Re-enable animation after updating
    //     }, 500);
    // };
    return (
        <div key={"slide" + currentSlide} className={`relative flex w-full flex-col justify-center pb-8`}>
            <div
                className={`h-[280px] transform transition-all duration-500 ${isAnimating ? "-translate-x-full opacity-0" : "translate-x-0 opacity-100"}`}
                key={"section" + currentSlide} // Key ensures the transition triggers on slide change
            >
                <h1
                    style={{ lineHeight: "2.6rem" }}
                    className="bg-gradient-to-r from-rose-400 via-fuchsia-500 to-indigo-500 bg-clip-text text-center text-3xl font-extrabold text-transparent md:text-4xl lg:text-left"
                >
                    {slides[currentSlide].heading}
                </h1>
                <p className="text-md mt-4 max-w-5xl text-center font-light lg:text-left">{slides[currentSlide].subheading}</p>
            </div>

            <div className="absolute bottom-0 flex justify-center space-x-3">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => handleSlideChange(index)}
                        className={`h-2 w-2 rounded-full ${
                            index === currentSlide
                                ? "scale-125 bg-white" // Highlight the active dot
                                : "bg-gray-500"
                        } transition-all duration-300`}
                    ></button>
                ))}
            </div>
        </div>

        // <div className={`flex h-[300px] w-full flex-col justify-center transform transition-all duration-500 ${ animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        //     <h1 className="bg-gradient-to-r from-rose-400 via-fuchsia-500 to-indigo-500 bg-clip-text text-center text-3xl font-extrabold text-transparent md:text-4xl lg:text-left">
        //         {slides[currentSlide].heading}
        //     </h1>
        //     <p className="text-md mt-4 max-w-5xl text-center font-light lg:text-left">{slides[currentSlide].subheading}</p>
        // </div>
    );
};

export default Carousel;
